module.exports = __webpack_public_path__ + "assets/oracle-bluekai.257a79c8.svg";